import repo from '@/repositories'

export default {
  add(service, data) {
    try {
      return repo.MajorSchoolRepository.add(data).then(
        res => Promise.resolve(res),
        err => Promise.reject(err),
      )
    } catch (err) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({ message: `Services error: ${service} service doesn't has add method` })
    }
  },
  destroy(service, firstUuid, secondUuid) {
    try {
      return repo.MajorSchoolRepository.destroy(firstUuid, secondUuid).then(
        res => Promise.resolve(res),
        err => Promise.reject(err),
      )
    } catch (err) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({ message: `Services error: ${service} service has no delete method` })
    }
  },
}
